export default "__VITE_ASSET__$P6EaRuG__"